import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input } from 'rsuite';
import { throttle } from '@src/helpers/throttle';
import {
  getCampaignElementById,
  updateCampaignElementValue
} from '@src/redux/modules/campaignLandingPage';
import styles from '@src/components/CampaignLanding/TextAreaInput.module.less';
import ElementDescription from '@src/components/CampaignLanding/ElementDescription';

const TextAreaInput = ({ _updateCampaignElementValue, element, qid }) => {
  const [isTouched, setIsTouched] = useState(false);
  const [isValid, setIsValid] = useState(true);

  return (
    <section
      className={`${styles.vpTextInputContainer} ${
        element.required && !isValid && styles.vpInvalidField
      }`}
    >
      <label className={styles.vpTextInputLabel}>
        {element.label}
        {element.required && <span className={styles.vpRequiredLabel}>*</span>}
      </label>
      <ElementDescription description={element?.description} />
      <Input
        componentClass="textarea"
        maxLength={65000}
        rows={5}
        className={styles.vpCustomInput}
        onChange={(val) => {
          if (element.required && val === '') {
            setIsValid(false);
          }
          setIsTouched(true);
          if (!element.required && val === '') {
            setIsTouched(false);
          }
          if (element.required) {
            setIsValid(val !== '');
          }
          throttle(() => _updateCampaignElementValue({ qid, value: val }), 1000)();
        }}
      />
      {element.required && isTouched && !isValid && (
        <div className={styles.vpErrorMessage}>This field is required</div>
      )}
    </section>
  );
};

TextAreaInput.propTypes = {
  _updateCampaignElementValue: PropTypes.func,
  qid: PropTypes.string,
  element: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  return {
    element: getCampaignElementById(state, ownProps.qid)
  };
}

const mapDispatchToProps = {
  _updateCampaignElementValue: updateCampaignElementValue
};

export default connect(mapStateToProps, mapDispatchToProps)(TextAreaInput);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/TextAreaInput.jsx